module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("\n      You are "), (!_vm.user.email) ? _c('span', [_vm._v("anonymous")]) : _c('span', [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('button', {
    staticClass: "float right",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Clicking the "), _c('em', [_vm._v("Add Message")]), _vm._v(" button will add a record to your user's messages"), (!_vm.user.email) ? _c('span', [_vm._v(", even anonymously")]) : _vm._e(), _vm._v(".")]), _vm._v(" "), (_vm.user.uid) ? _c('button', {
    on: {
      "click": _vm.addMessage
    }
  }, [_vm._v("Add Message\n  ")]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.messages), function(message) {
    return _c('li', [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeMessage(message)
        }
      }
    }, [_vm._v("remove")]), _vm._v(" " + _vm._s(message))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a00274b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 172
// module chunks = 1